import { render, staticRenderFns } from "./FilterStockTransferRequestStatuses.vue?vue&type=template&id=0fbd8b61&scoped=true&lang=pug&"
import script from "./FilterStockTransferRequestStatuses.vue?vue&type=script&lang=js&"
export * from "./FilterStockTransferRequestStatuses.vue?vue&type=script&lang=js&"
import style0 from "./FilterStockTransferRequestStatuses.vue?vue&type=style&index=0&id=0fbd8b61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbd8b61",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDivider,VIcon,VMenu,VSpacer})
